import { Link } from "react-router-dom";
import { uploadUrl } from "../../lib/assets";
import HighlightText from "./HighlightText";

/**
 * @param {{ post: { id: string, title: string, cat: string, img: string, date: string, read: string, short: string, blurb: string, kw: string, featured?: boolean }, query: string, compact?: boolean }} props
 */
export default function BlogCard({ post, query, compact = false }) {
  const imageUrl = uploadUrl(post.img);

  return (
    <Link
      to={`/blog/${post.id}`}
      className={`blog-card${compact ? " blog-card--compact" : ""}`}
    >
      <div
        className="blog-card__image"
        style={{ backgroundImage: `url('${imageUrl}')` }}
      />
      <div className="blog-card__category">{post.cat.toUpperCase()}</div>
      <div className="blog-card__title">
        <HighlightText text={post.title} query={query} />
      </div>
      {!compact && <p className="blog-card__blurb">{post.blurb}</p>}
      <div className="blog-card__meta">
        {post.date} · {post.read}
      </div>
    </Link>
  );
}
